import { isRealYear } from 'utilities/dateHelper/dateHelper';
import validator from 'validator';
import { MAX_VALID_AGE, MIN_VALID_AGE, VULNERABLY_AGE } from 'components/newAccountSteps/initialStep/constants';
import { birthDayMatchesPassword, birthYearMatchesPassword } from 'commons-components/src/utilities/validations';

const BASE_VALIDATION_RESPONSE = {
    actionsToDispatch: [],
    isOlder: true,
    isValid: true,
    isVulnerablyOlder: false,
    dateString: '',
};

const validateDateString = (value, type) => {
    let valid = true;
    const birthDateString = value;
    if (typeof birthDateString !== 'undefined') {
        let age;
        if (type === 'older') {
            const today = new Date();
            const birthDate = new Date(birthDateString);
            const m = today.getMonth() - birthDate.getMonth();
            age = today.getFullYear() - birthDate.getFullYear();
            if (age < MIN_VALID_AGE && age > 0) {
                valid = false;
            } else if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
                if (age < MIN_VALID_AGE && age >= 0) {
                    valid = false;
                }
            }
        } else if (type === 'vDate') {
            valid = validator.isDate(birthDateString);
            if (valid) {
                const today = new Date();
                const birthDate = new Date(birthDateString);
                const m = today.getMonth() - birthDate.getMonth();
                age = today.getFullYear() - birthDate.getFullYear();

                if (age > MAX_VALID_AGE || age <= 0) {
                    valid = false;
                } else if (m > 0 || (m === 0 && today.getDate() >= birthDate.getDate())) {
                    age++;
                    if (age > MAX_VALID_AGE || age < 0) {
                        valid = false;
                    }
                }
            }
        } else if (type === 'notVulnerablyOlder') {
            const today = new Date();
            const birthDate = new Date(birthDateString);
            const m = today.getMonth() - birthDate.getMonth();
            age = today.getFullYear() - birthDate.getFullYear();
            if (age > VULNERABLY_AGE) {
                valid = false;
            } else if (m > 0 || (m === 0 && today.getDate() >= birthDate.getDate())) {
                age++;
                if (age > VULNERABLY_AGE || age < 0) {
                    valid = false;
                }
            }
        }
    } else {
        valid = false;
    }

    return valid;
};

const formatDateToValidate = ({ birthDay, birthMonth, birthYear }) => {
    const formattedDay = birthDay.length < 2 ? `0${birthDay}` : birthDay;
    const formattedMonth = birthMonth.length < 2 ? `0${birthMonth}` : birthMonth;

    return `${birthYear}/${formattedMonth}/${formattedDay}`;
};

export const validateBirthDate = ({ birthDay = '', birthMonth = '', birthYear = '', password }) => {
    const dateRegExp =
        /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/g;

    if (birthDay === '' || birthMonth === '' || birthYear === '') {
        return {
            ...BASE_VALIDATION_RESPONSE,
            actionsToDispatch: [
                {
                    field: 'birthDate',
                    validation: 'required',
                },
            ],
            isValid: false,
        };
    }
    const dateFormatToValidate = `${birthDay}/${birthMonth}/${birthYear}`;

    if (birthYear.length < 4) {
        return {
            ...BASE_VALIDATION_RESPONSE,
            actionsToDispatch: [
                {
                    field: 'birthDate',
                    validation: 'validYearLength',
                },
            ],
            isValid: false,
        };
    }

    if (!dateFormatToValidate.match(dateRegExp)) {
        return {
            ...BASE_VALIDATION_RESPONSE,
            actionsToDispatch: [
                {
                    field: 'birthDate',
                    validation: 'valid',
                },
            ],
            isValid: false,
        };
    }

    if (password && birthYear && birthYearMatchesPassword(password, birthYear)) {
        return {
            ...BASE_VALIDATION_RESPONSE,
            actionsToDispatch: [
                {
                    field: 'birthYear',
                    validation: 'required',
                },
                {
                    field: 'birthDate',
                    validation: 'validPinBirthDate',
                },
            ],
            isValid: false,
        };
    }

    if (password && birthDay && birthMonth && birthDayMatchesPassword(password, birthDay, birthMonth)) {
        return {
            ...BASE_VALIDATION_RESPONSE,
            actionsToDispatch: [
                {
                    field: 'birthDay',
                    validation: 'required',
                },
                {
                    field: 'birthMonth',
                    validation: 'required',
                },
                {
                    field: 'birthDate',
                    validation: 'validPinBirthDate',
                },
            ],
            isValid: false,
        };
    }

    const dateString = formatDateToValidate({ birthDay, birthMonth, birthYear });
    const isOlder = validateDateString(dateString, 'older');
    const isNotVulnerablyOlder = validateDateString(dateString, 'notVulnerablyOlder');
    const isValid = isRealYear(birthYear) ? validateDateString(dateString, 'vDate') : false;

    return {
        ...BASE_VALIDATION_RESPONSE,
        isOlder,
        isValid,
        dateString,
        isVulnerablyOlder: !isNotVulnerablyOlder,
    };
};
